module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-inverse navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logout")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-2 sidebar"
  }, [_c('ul', {
    staticClass: "nav nav-sidebar"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-dashboard"
  }), _vm._v(" Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "new",
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" New Notification")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "history",
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v(" History")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("DiningCity Push Notification Service")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d3ade58a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 41
// module chunks = 1